import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Create axios instance with interceptors
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fetchDashboardStats = createAsyncThunk(
  'dashboard/fetchStats',
  async () => {
    try {
      const response = await api.get('/api/dashboard/stats');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);

export const fetchProjectTrends = createAsyncThunk(
  'dashboard/fetchProjectTrends',
  async () => {
    try {
      const response = await api.get('/api/dashboard/projects/trends');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);

export const fetchUserStats = createAsyncThunk(
  'dashboard/fetchUserStats',
  async () => {
    try {
      const response = await api.get('/api/dashboard/users/stats');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);
